<script>
import Static from "@/views/Static.vue";

export default {
    name: "About",
    extends: Static
};
</script>
